/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FunctionComponent, useState } from 'react';
import Checkbox from '../../Checkbox/Checkbox';
import Icon from '../../../DataDisplay/Icon/Icon';
import LockedFeatureDialogue from '../../../Compound/LockedFeatureDialogue/LockedFeatureDialogue';
import styles from './MultiSeletorItem.module.scss';

type MultiSeletorItemProps = {
  idx: number;
  label: string;
  isChecked?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isLocked?: boolean;
  labelPosition?: 'left' | 'right';
  labelSize?: string;
  size?: 'xsm' | 'sm' | 'lg';
  identifier?: string;
  itemHeight?: string;
  lockedItemContact?: () => void;
  onClick: (idx: number, isChecked: boolean) => void;
};

type FC = FunctionComponent<MultiSeletorItemProps>;

const MultiSeletorItem: FC = ({
  idx,
  label = 'MultiSeletorItem',
  isChecked = false,
  isReadOnly = false,
  isDisabled = false,
  isLocked = false,
  labelPosition = 'left',
  labelSize,
  size,
  identifier,
  itemHeight,
  lockedItemContact = () => {},
  onClick,
}: MultiSeletorItemProps) => {
  const [isDialogueVisible, setIsDialogueVisible] = useState(false);

  const handleClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    onClick(idx, newChecked);
  };

  return (
    <>
      <LockedFeatureDialogue
        isVisible={isDialogueVisible}
        lockedFeature={label}
        cancel={() => {
          setIsDialogueVisible(false);
        }}
        contactOutTeam={lockedItemContact}
      />
      <div style={{ height: itemHeight }} className={styles.itemContainer}>
        {isLocked ? (
          <div
            className={styles.lockedItem}
            onClick={() => {
              setIsDialogueVisible(true);
            }}
          >
            <Icon icon="lock2" color="low-light" width="20px" height="20px" />
            <span dangerouslySetInnerHTML={{ __html: label }} />
          </div>
        ) : (
          <div className={[styles.itemContainer, isDisabled ? styles.disabled : ''].join(' ')}>
            <Checkbox
              name={identifier !== '' ? `multi-select-${identifier || ''}-${idx}` : `multi-select-${idx}`}
              value={isChecked}
              hasNoPadding
              onBlur={() => {}}
              readOnly={isReadOnly}
              disabled={isDisabled}
              onChange={handleClick}
              label={<div dangerouslySetInnerHTML={{ __html: label }} />}
              labelPosition={labelPosition}
              labelSize={labelSize}
              size={size}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MultiSeletorItem;
